import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { logisticsApi, type Carrier } from '../../api/logistics';

export function CarriersPage() {
  const [carriers, setCarriers] = useState<Carrier[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void logisticsApi.listCarriers().then(setCarriers).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/logistics" className="text-sm text-slate-600 hover:underline">← Logistics hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Carrier dashboard</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {carriers.map((c) => (
          <div key={c.id} className="rounded-xl border p-4">
            <p className="font-semibold">{c.name}</p>
            <p className="text-xs text-slate-500">{c.code}</p>
            <p className="mt-1 text-sm">SLA: {c.sla_days} days · Priority {c.priority}</p>
            <p className="text-sm">{c.active ? 'Active' : 'Suspended'}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
